import script from "./Loader.vue?vue&type=script&setup=true&lang=js"
export * from "./Loader.vue?vue&type=script&setup=true&lang=js"

import "./Loader.vue?vue&type=style&index=0&id=9909d400&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2870471937/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9909d400"]])

export default __exports__